import React from 'react'

const SortPanel = ({
    children,
    title
}) => {
    return (
        <section className="sortPanel">
            <div className="sortPanel__caption">{title ? title : "Сортировка"}</div>
            {children}
        </section>
    )
}

export default SortPanel